import { Component, OnInit, Input, SimpleChanges, forwardRef, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { IonIcon, IonModal, IonContent, IonSpinner, IonFooter, IonToolbar, IonGrid, IonRow, IonCol } from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';

import { DemoozButtonComponent } from '@demooz/components';
import { DemoozModalService } from '@demooz/services';

export class DemoozInputPicture {    
    urlImage?: string;
    objectUrl?: SafeUrl;
    blobImage?: Blob;
    newPicture: boolean = true;
    constructor(urlImage?: string){
        if(urlImage && urlImage != ''){
            this.urlImage = urlImage;
            this.newPicture = false;
        }
    }
}

@Component({
    selector: 'demooz-input-picture',
    templateUrl: './input-picture.component.html',
    styleUrls: ['./input-picture.component.scss'],
    imports: [
        IonIcon, IonModal, IonContent, IonSpinner, IonFooter, IonToolbar, IonGrid, IonRow, IonCol,
        TranslatePipe, ReactiveFormsModule, ImageCropperComponent, forwardRef(()=> DemoozButtonComponent)],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class DemoozInputPictureComponent  implements OnInit {

    @Input({alias : 'file', required : false}) file: DemoozInputPicture|null = null;
    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'indication', required : false}) indicationInput: string = '';
    @Input({alias : 'icon', required : false}) iconInput: string = '';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MAIN.MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'showBtnClearInput', required : false}) showBtnClearInput: boolean = true;
    @Input({alias : 'acceptFiles', required : false}) acceptFiles: Array<string> = ['png', 'jpg', 'jpeg'];
    @Input({alias : 'altValue', required : false}) altValue: string = 'P';
    @Output() fileChange = new EventEmitter<DemoozInputPicture|null>();
     
    @ViewChild('demoozInputFile') demoozInputFile: ElementRef;
    @ViewChild('modalCropPicture') modalCropPicture: IonModal;
     
    isRequired: boolean = false;    
    isFetchingPicture: boolean = false;    
    updateStatusChange: Subscription;
    imageChangedEvent: Event|null = null;
    tempPicture: DemoozInputPicture|null = null;

    constructor(
        private sanitizer: DomSanitizer,
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective,
        private demoozModalService: DemoozModalService
    ) { }
    
    ngOnInit() {
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required); 
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });   
    }

    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }    
    
    getAcceptFiles(): string{
        let accept = '';
        if(this.acceptFiles.length > 0){
            accept = this.acceptFiles.map(f => { return (f.charAt(0) !== '.' ? '.'+f : f) }).join(', ');
        }
        return accept;
    }    
    
    clearInput($event: any){
        $event.stopPropagation();  
        if(!this.disabled){
            if(this.formGroupDirective.form.controls[this.formName]){
                this.formGroupDirective.form.controls[this.formName].setValue(null);
                this.file = null;
                this.fileChange.emit(this.file);
            }
        }
    }
    
    selectFile(){        
        if(!this.disabled){
            this.demoozInputFile.nativeElement.click();
        }
    }
    
    onChangeFile($event: any){
        if($event.target?.files?.length > 0){
            this.isFetchingPicture = true;
            this.imageChangedEvent = $event;
            this.demoozModalService.open(this.modalCropPicture);
        }        
    }
    
    async canDismissCropPictureModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    async onDidDismissCropPictureModal($event: any){
        this.demoozModalService.onDidDismiss($event);  
        this.tempPicture = null;
        this.demoozInputFile.nativeElement.value = null;
        this.isFetchingPicture = false;
    }
    
    async closeCropPictureModal() {
        this.modalCropPicture.dismiss();
    }
    
    imageCropped(event: ImageCroppedEvent) {
        if(event.objectUrl && event.blob){
            let file = new DemoozInputPicture();
            file.objectUrl = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
            file.blobImage = event.blob;
            this.tempPicture = file;
        }
    }
    
    imageLoaded(image: LoadedImage) {
        this.isFetchingPicture = false;
    }
    
    cropperReady() {
        
    }
    
    loadImageFailed() {
        this.isFetchingPicture = false;
        this.closeCropPictureModal();
    }
    
    validatePicture(){              
        this.file = this.tempPicture;
        this.fileChange.emit(this.file);
        this.closeCropPictureModal();
    }
    
    cancelPicture(){                
        this.closeCropPictureModal();
    }
}
